// API Configuration
export const API_BASE_URL =
  import.meta.env.VITE_API_URL || "https://api.sv.gonau.co";
export const API_ORDER_SERVICE_URL =
  import.meta.env.VITE_API_ORDER_SERVICE_URL ||
  "https://order-service-578126443434.us-central1.run.app";

// Auth0 Configuration Constants
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
